import React, { Suspense } from "react";
import ProtectedRoute from "../components/common/ProtectedRoute";
import { RouteSuspenseFallback } from "./RouteSuspenseFallback";

interface LazyProtectedPageProps {
  children: React.ReactElement;
  loadingMessage: string;
  fallbackId?: string;
}

/** Protected route wrapper with Suspense fallback for lazy-loaded pages. */
export const LazyProtectedPage: React.FC<LazyProtectedPageProps> = ({
  children,
  loadingMessage,
  fallbackId,
}) => (
  <ProtectedRoute>
    <Suspense
      fallback={
        <RouteSuspenseFallback message={loadingMessage} id={fallbackId} />
      }
    >
      {children}
    </Suspense>
  </ProtectedRoute>
);
